













import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  isActive: boolean = false;
  html: HTMLElement;
  body: HTMLBodyElement;

  constructor() {
    super();
    this.html = document.querySelector("html") as HTMLElement;
    this.body = document.body as HTMLBodyElement;
  }

  async open() {
    this.html.classList.add("no-scroll");
    this.isActive = true;
    this.body.addEventListener("mouseup", this.closeIfClickedOutside);
  }

  close() {
    this.isActive = false;
    this.body.removeEventListener("mouseup", this.closeIfClickedOutside);
    this.html.classList.remove("no-scroll");
  }

  closeIfClickedOutside(event: Event) {
    if (!this.isActive) {
      return;
    }

    if (!this.html.classList.contains("no-scroll")) {
      return;
    }

    if (!(event.target as Node).contains(this.$el)) {
      return;
    }

    this.close();
  }
}
